// extracted by mini-css-extract-plugin
module.exports = {"root":"e_Kib","heading":"e_Lib","text":"e_Mib","link":"e_Nib"};